import { Navigate, Outlet, createFileRoute } from '@tanstack/react-router';

import { DocumentTitle } from '@/components/DocumentTitle';
import { Navbar } from '@/components/Navbar/Navbar';
import { GRONDSLAGEN } from '@/constants/grondslagen';
import { eStrings } from '@/constants/strings';
import { isUserAuthenticatedForRoute } from '@/stores/user/isUserAuthenticatedForRoute';
import { useIsExactMatch } from '@/utils/hooks/useIsExactMatch';

/**
 * Route
 */
export const Route = createFileRoute('/beheer')({
  beforeLoad: async ({ preload }) => {
    await isUserAuthenticatedForRoute({ preload, allowed: ['Beheerder'] });
  },
  component: BeheerComponent,
});

/**
 * Route component
 */
function BeheerComponent() {
  /**
   * Because /beheer is not an actual route, navigate to /beheer/labels if it's an exact match
   */
  const isExactMatch = useIsExactMatch(Route.id);

  if (isExactMatch) {
    return (
      <Navigate
        to="/beheer/standaardteksten/$grondslagId"
        params={{ grondslagId: GRONDSLAGEN[0].id }}
        search={{ p: 1 }}
      />
    );
  }

  return (
    <>
      <Navbar />

      <DocumentTitle sections={[eStrings.LBL_DIGI_V, 'Beheer']} />

      <div className="container-default py-5">
        <Outlet />
      </div>
    </>
  );
}
